import { createFileRoute } from '@tanstack/react-router';
import { TemplateDetail } from '@features/document-templates/TemplateDetail';

export const Route = createFileRoute('/w/document-templates/$templateId')({
  staticData: { breadcrumb: 'Template Detail', breadcrumbKey: 'K_BREADCRUMB_TEMPLATE_DETAIL' },
  validateSearch: (search: Record<string, unknown>) => ({
    edit: search.edit === 'true' || search.edit === true,
  }),
  component: WorkpayTemplateDetailPage,
});

function WorkpayTemplateDetailPage() {
  const { templateId } = Route.useParams();
  const { edit } = Route.useSearch();
  return <TemplateDetail templateId={templateId} routeTo="/w/document-templates" initialEdit={edit} />;
}
